import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./styles/global.css";

// OneDrive OAuth popup bridge: the Microsoft callback redirects back into the
// SPA with ?onedrive=connected|error. When we're running inside the consent
// popup (window.opener set), relay the result to the opener and close — so the
// user stays exactly where they were (their case) instead of being navigated
// to the app root.
(() => {
  try {
    const params = new URLSearchParams(window.location.search);
    const result = params.get("onedrive");
    if (result && window.opener && window.opener !== window) {
      window.opener.postMessage({ source: "onedrive-oauth", result }, window.location.origin);
      window.close();
    }
  } catch {
    /* ignore — fall through to normal app render */
  }
})();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
